<template>
  <section :class="['backup-edit__sms-mms', {['backup-edit__with-extension']: parentExtension}]">
    <sms
        :isRounded="smsIsRounded"
        messageModuleName="backup"
        smsSend
        @updateCampaign="updateBackupCampaign">
    </sms>
    <mms
        v-show="!hasAd"
        isMmsOpen
        :isSmsBackup="isSmsBackup"
        :mediaError="mmsError"
        messageModuleName="backup"
        ref="mms"
        @getAttachedMedia="$emit('getAttachedMedia')"
        @updateCampaign=updateBackupCampaign>
    </mms>
    <aside v-if="parentExtension" class="backup-edit__extension">
      <span class="backup-edit__extension--text">{{parentExtension}}</span>
    </aside>
  </section>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import Mms from '../MediaAttachments/Mms'
  import Sms from '../Sms/Sms'

  export default {
    props: {
      hasAd: Boolean,
      isSmsBackup: Boolean,
      mmsError: String,
    },

    name: 'CampaignBackupContent',

    components: {
      Mms,
      Sms
    },

    methods: {
      finishGettingAttachedMedia() {
        this.$refs?.mms.finishGettingAttachedMedia()
      },

      updateBackupCampaign(dataToUpdate) {
        this.$emit('updateBackupCampaign', dataToUpdate)
      },

      ...mapActions({
        UPDATE_MESSAGE_STATE: 'backup/UPDATE_MESSAGE_STATE',
      }),
    },

    created() {
      this.UPDATE_MESSAGE_STATE({ stateKey: 'extensionType', stateItem: this.parentExtensionType })
    },

    computed: {
      parentExtension: function () {
        let extension
        switch (this.parentExtensionType) {
          case 1:
          case 5:
          case 6:
            extension = 'track offer'
            break
          case 3:
            extension = 'target wallet'
            break
          case 4:
            extension = 'any link'
            break
        }
        return extension && !this.errors?.extensions ? `${extension} configured` : null
      },

      smsIsRounded: function () {
        const noParentExtension = !this.parentExtension
        return noParentExtension && this.hasAd
      },

      ...mapState({
        errors: state => state.errors,
        parentExtensionType: state => state.message.extensionType
      }),
    },

    watch: {
      parentExtensionType: function () {
        this.UPDATE_MESSAGE_STATE({
          stateKey: 'extensionType',
          stateItem: this.parentExtensionType
        })
      }
    }
  }
</script>
